import { render } from "./Spinner.vue?vue&type=template&id=d6f8095c"
const script = {}

import "./Spinner.vue?vue&type=style&index=0&id=d6f8095c&lang=scss"
script.render = render

export default script